/**
 * What the Packs page lists under its area and role selection, the same on
 * the web and on the phone. Pure logic over the packs list.
 */

import {
  ALL_AREAS,
  type AreaRoleSelection,
  filterByAreaAndRole,
  matchesRoles,
} from "./areaRoleFilter.ts";
import type { PackResp } from "@/types/packs.ts";

export type PackList = {
  rolePacks: PackResp[];
  areaPacks: PackResp[];
  /** The area packs under the roles, in every area: what the area pills count. */
  areaPacksForPills: PackResp[];
};

/**
 * Area packs filter by their own area and roles. A role pack has no area of
 * its own, so under an area pill it shows when it lists an area pack that the
 * pill shows; under the roles it filters by its own roles.
 */
export const packsForSelection = (
  packs: readonly PackResp[],
  selection: AreaRoleSelection | undefined,
): PackList => {
  const { narrowed, visible } = filterByAreaAndRole(
    packs.filter((p) => p.kind === "area"),
    selection,
    () => true,
  );
  const visibleAreaIds = new Set(visible.map((p) => p.id));
  const rolePacks = packs.filter(
    (p) =>
      p.kind === "role" &&
      (!selection ||
        (matchesRoles(p, selection.roles) &&
          (selection.area === ALL_AREAS || (p.packs ?? []).some((id) => visibleAreaIds.has(id))))),
  );
  return { rolePacks, areaPacks: visible, areaPacksForPills: narrowed };
};
